<template>
  <div ref="">
    <div class="toolbar-sport-tree" v-if="gameMode === 'preview'">
      <v-tabs
        background-color="dark accent-4"
        center-active
        show-arrows
        dark
        class="toolbar-sport-tree-tabs"
      >
        <v-tab
          v-for="(sport, index) in this.getTreeV2"
          :key="sport.id"
          @click="selectSport(sport)"
        >
          <template v-if="sport.type == 'sport'">
            <div class="single-tab">
              <img
                v-if="sport.type == 'sport'"
                :src="
                  sportPath + returnIcon(getIcon) + '/' + sport.icon_id + '.svg'
                "
                :alt="sport.name"
                v-bind:class="{ 'img-sport-light': light }"
              />
              <span class="name">{{ sport.name }}</span>
            </div>
          </template>
          <template v-else>
            <div class="single-tab">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M8.61312 21.7542H3.46298C3.2727 21.7542 3.11414 21.5957 3.11414 21.4054V16.9277C3.11414 16.7374 3.2727 16.5789 3.46298 16.5789H8.61312C8.8034 16.5789 8.96196 16.7374 8.96196 16.9277V21.4054C8.96196 21.602 8.80974 21.7542 8.61312 21.7542ZM3.81181 21.0566H8.26429V17.2765H3.81181V21.0566Z"
                  fill="currentColor"
                />
                <path
                  d="M20.499 21.7542H15.3488C15.1586 21.7542 15 21.5957 15 21.4054V18.3928C15 18.2025 15.1586 18.044 15.3488 18.044H20.499C20.6892 18.044 20.8478 18.2025 20.8478 18.3928V21.4054C20.8478 21.602 20.6892 21.7542 20.499 21.7542ZM15.6977 21.0566H20.1501V18.748H15.6977V21.0566Z"
                  fill="currentColor"
                />
                <path
                  d="M15.3489 21.7542H8.65121C8.46093 21.7542 8.30237 21.5957 8.30237 21.4054V12.5325C8.30237 12.3422 8.46093 12.1836 8.65121 12.1836H15.3489C15.5392 12.1836 15.6978 12.3422 15.6978 12.5325V21.4054C15.6978 21.602 15.5392 21.7542 15.3489 21.7542ZM9.00005 21.0566H14.9937V12.8876H9.00005V21.0566Z"
                  fill="currentColor"
                />
                <path
                  d="M11.9937 18.748C11.8035 18.748 11.6449 18.5894 11.6449 18.3991V15.7607H11.5434C11.3531 15.7607 11.1946 15.6022 11.1946 15.4119C11.1946 15.2216 11.3531 15.0631 11.5434 15.0631H11.9937C12.184 15.0631 12.3426 15.2216 12.3426 15.4119V18.3991C12.3489 18.5894 12.1903 18.748 11.9937 18.748Z"
                  fill="currentColor"
                />
                <path
                  d="M11.981 11.7397C9.3552 11.7397 7.21777 9.60231 7.21777 6.97658C7.21777 4.35085 9.3552 2.21347 11.981 2.21347C14.6068 2.21347 16.7443 4.35085 16.7443 6.97658C16.7443 9.60231 14.6068 11.7397 11.981 11.7397ZM11.981 2.91113C9.74209 2.91113 7.91545 4.73139 7.91545 6.97658C7.91545 9.22177 9.73575 11.042 11.981 11.042C14.2263 11.042 16.0466 9.22177 16.0466 6.97658C16.0466 4.73139 14.2199 2.91113 11.981 2.91113Z"
                  fill="currentColor"
                />
                <path
                  d="M12.7167 8.3909H11.2516C11.0994 8.3909 10.9725 8.29579 10.9218 8.15625L10.4714 6.83703C10.4207 6.69115 10.4778 6.52627 10.6046 6.43747L11.7907 5.62563C11.9112 5.54318 12.0698 5.54318 12.1839 5.62563L13.37 6.43747C13.4968 6.52627 13.5539 6.69115 13.5032 6.83703L13.0529 8.15625C12.9958 8.29579 12.8626 8.3909 12.7167 8.3909ZM11.4989 7.69325H12.4693L12.7548 6.86239L11.9873 6.33599L11.2199 6.86239L11.4989 7.69325Z"
                  fill="currentColor"
                />
                <path
                  d="M10.4461 11.4669C10.332 11.4669 10.2242 11.4162 10.1607 11.3147C10.0529 11.1562 10.091 10.9405 10.2495 10.8264L11.7844 9.77355C11.9049 9.6911 12.0635 9.6911 12.1777 9.77355L13.7125 10.8264C13.8711 10.9342 13.9092 11.1562 13.8013 11.3147C13.6935 11.4733 13.4715 11.5113 13.313 11.4035L11.9747 10.4902L10.6364 11.4035C10.5857 11.4479 10.5159 11.4669 10.4461 11.4669Z"
                  fill="currentColor"
                />
                <path
                  d="M9.18394 10.7376C9.1776 10.7376 9.1649 10.7376 9.15856 10.7376C8.96828 10.7249 8.82241 10.5537 8.8351 10.3634L8.94925 8.74609L7.48414 8.05478C7.30655 7.97233 7.23677 7.76301 7.31922 7.59177C7.40168 7.41419 7.61098 7.34444 7.78223 7.4269L9.463 8.21969C9.5962 8.28311 9.67231 8.41629 9.65963 8.56217L9.52643 10.4141C9.52009 10.598 9.36153 10.7376 9.18394 10.7376Z"
                  fill="currentColor"
                />
                <path
                  d="M8.18814 5.06751C8.01055 5.06751 7.85199 4.92797 7.8393 4.74405C7.82662 4.55378 7.96616 4.38254 8.16278 4.36985L9.78012 4.24301L10.2431 2.68913C10.3002 2.50521 10.4905 2.39737 10.6808 2.45445C10.8647 2.51154 10.9725 2.70183 10.9154 2.8921L10.3827 4.67427C10.3383 4.81381 10.2178 4.90897 10.0782 4.92165L8.2262 5.06751C8.20083 5.06751 8.19448 5.06751 8.18814 5.06751Z"
                  fill="currentColor"
                />
                <path
                  d="M14.7781 10.7376C14.5942 10.7376 14.442 10.598 14.4293 10.4141L14.2961 8.56215C14.2834 8.41628 14.3659 8.2831 14.4927 8.21967L16.1735 7.42688C16.3511 7.34443 16.554 7.42051 16.6365 7.59176C16.7189 7.76934 16.6428 7.97232 16.4716 8.05477L15.0128 8.74608L15.127 10.3634C15.1396 10.5536 14.9938 10.7249 14.8035 10.7376C14.7971 10.7376 14.7845 10.7376 14.7781 10.7376Z"
                  fill="currentColor"
                />
                <path
                  d="M15.7739 5.06751C15.7675 5.06751 15.7548 5.06751 15.7485 5.06751L13.8965 4.92165C13.7506 4.90897 13.6301 4.81381 13.592 4.67427L13.0593 2.8921C13.0022 2.70817 13.11 2.51154 13.2939 2.45445C13.4779 2.39737 13.6745 2.50521 13.7316 2.68913L14.1946 4.24301L15.8119 4.36985C16.0022 4.38254 16.1481 4.55378 16.1354 4.74405C16.11 4.93432 15.9578 5.06751 15.7739 5.06751Z"
                  fill="currentColor"
                />
              </svg>
              <span class="name">{{ sport.name }}</span>
            </div>
          </template>
        </v-tab>
      </v-tabs>
      <div
        class="single-tab live cursor-pointer text-capitalize"
        @click="changeLiveMode('detail')"
      >
        <!--        <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 16 16" fill="none"><g id="Hicon / Linear / Home 2" clip-path="url(#clip0_6758_9874)"><g id="Group"><path id="Vector" d="M8.00008 15.3333C12.0502 15.3333 15.3334 12.0501 15.3334 8.00001C15.3334 3.94992 12.0502 0.666672 8.00008 0.666672C3.94999 0.666672 0.666748 3.94992 0.666748 8.00001C0.666748 12.0501 3.94999 15.3333 8.00008 15.3333Z" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_2" d="M6.66675 10.6667V5.33334L10.6667 8.00001L6.66675 10.6667Z" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/></g></g><defs><clipPath id="clip0_6758_9874"><rect width="16" height="16" fill="currentColor"/></clipPath></defs></svg>-->
        <img src="../../assets/gif/livev2.gif" width="30px" height="30px" />
        {{ $t('live') }}
      </div>

      <div class="loading-tree" v-if="loading">
        <v-progress-circular
          :size="100"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </div>
    <div class="toolbar-sport-tree-live" v-if="gameMode !== 'preview'">
      <v-tabs
        background-color="dark accent-4"
        center-active
        show-arrows
        dark
        class="toolbar-sport-tree-tabs"
      >
        <v-tab
          v-for="(item, index) in this.getCountLive"
          :key="$uuid.v1()"
          @click="changeLiveSport(item.sport)"
        >
          <div class="single-tab">
            <img
              :src="sportPathLive + item.sport.id + '.svg'"
              class="sport-icon"
              v-bind:class="{ 'img-sport-light': light }"
            />
            <span class="name">{{ getTitle(item.sport) }}</span>
          </div>
        </v-tab>
      </v-tabs>
      <div
        class="single-tab live cursor-pointer text-capitalize"
        @click="changeLiveMode('preview')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clip-path="url(#clip0_2929_11404)">
            <path
              d="M14.5 2.5H1.5C0.948 2.5 0.5 2.948 0.5 3.5V14.5C0.5 15.052 0.948 15.5 1.5 15.5H14.5C15.052 15.5 15.5 15.052 15.5 14.5V3.5C15.5 2.948 15.052 2.5 14.5 2.5Z"
              stroke="#FFFFFF"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M0.5 5.5H15.5"
              stroke="#FFFFFF"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4.5 0.5V2.5"
              stroke="#FFFFFF"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.5 0.5V2.5"
              stroke="#FFFFFF"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5.5 7.5V13.5"
              stroke="#FFFFFF"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.5 7.5V13.5"
              stroke="#FFFFFF"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2.5 10.5H13.5"
              stroke="#FFFFFF"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2929_11404">
              <rect width="16" height="16" fill="#FFFFFF" />
            </clipPath>
          </defs>
        </svg>
        {{ $t('prematch') }}
      </div>

      <div class="loading-tree" v-if="loading">
        <v-progress-circular
          :size="100"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isMobileOnly, isTablet } from 'mobile-device-detect'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '@/plugins/device-inspector'

export default {
  name: 'ToolbarSportsTree',
  data: () => ({
    loading: false,
    sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/',
    sportPathLive: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/icons/',
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    light: window.icons == 'light' ? true : false,
  }),
  props: {
    gameMode: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getTreeV2: 'treeV2/getTree',
      getIcon: 'settings/getIcon',
      getCountLive: 'odds/getCountLive',
      getIsCartOpen: 'cart/getIsCartOpen',
    }),
  },
  methods: {
    ...mapActions({
      fetchTreeV2Complete: 'treeV2/fetchTreeV2Complete',
      setLiveMode: 'odds/setLiveMode',
      setIsCartOpen: 'cart/setIsCartOpen',
      setSportSelectedInToolbarTree: 'treeV2/setSportSelectedInToolbarTree',
    }),
    selectSport(sport) {
      this.$root.$emit('changeNextEventsFromToolbarSports', sport)
      this.setSportSelectedInToolbarTree(sport)
      this.sendModeMessageToSkinV2('sportSelectedToolbarTree', sport)
    },
    changeLiveSport(sport) {
      this.$root.$emit('changeLiveSport', sport)
    },
    getTitle(item) {
      return _.find(item.detail, { lang: this.getLanguage }).text
    },
    checkIsMobile() {
      return checkIsMobileDevice()
    },
    checkIsTablet() {
      return checkIsTabletDevice()
    },
    returnIcon(icon) {
      let response
      switch (icon) {
        case 'B/W':
          response = 'icons'
          break
        case 'Color':
          this.light = false
          response = 'icons_color'
          break
      }
      return response
    },
    sendModeMessageToSkinV2(type, sport) {
      const vm = this
      const message = {
        type: type,
        sport: sport,
      }
      window.parent.postMessage(message, '*')
    },
    changeLiveMode(mode) {
      this.setLiveMode({ mode: mode })
    },
  },
  async created() {
    this.loading = true
    await this.fetchTreeV2Complete({})
    if (this.gameMode === 'preview') {
      this.sendModeMessageToSkinV2(
        'sportSelectedToolbarTree',
        this.getTreeV2[0]
      )
    }
    this.loading = false
  },
}
</script>
<style>
#preloadIcon {
  height: 25px;
  width: 25px;
  margin-right: 10px;
}

.img-sport-light {
  filter: invert(1);
}

.img-sport-dark {
  filter: invert(0);
}

body::-webkit-scrollbar {
  display: none !important;
}

.card_tree_left_v2 {
  -ms-overflow-style: none !important;
}

/* ===== Scrollbar CSS ===== */
/* Firefox */
* {
  scrollbar-width: auto;
  scrollbar-color: #126e51;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 6px;
}

*::-webkit-scrollbar-track {
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}
</style>
